import { withJsonFormsControlProps } from '@jsonforms/react';
import { Text } from './Text';

const TextControl = ({ data, handleChange, path, schema, visible }) => {
  return (
    <Text
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      text={schema?.text ?? ''}
      type={schema?.heading}
      visible={visible}
    />
  );
};

export default withJsonFormsControlProps(TextControl);
